import React from 'react';
import { Row, Col } from 'antd';
import HumanReviewProgressCard from '../analytics-section/text/human-review-progress/HumanReviewProgressCard';
import ReviewedStatisticCard from './statistics/ReviewedStatisticCard';
import AverageTimePerReviewCard from './statistics/AverageTimePerReviewCard';
import EstimatedTimeToFinishCard from './statistics/EstimatedTimeToFinishCard';
import FullyReviewedCard from './statistics/FullyReviewedCard';

const ReviewerDashboard = () => {
  return (
    <div className="reviewer-dashboard">
      <Row gutter={16}>
        <Col xs={24} sm={12} lg={6}>
          <ReviewedStatisticCard/>
        </Col>        
        
        <Col xs={24} sm={12} lg={6}>
          <FullyReviewedCard/>
        </Col>

        <Col xs={24} sm={12} lg={6}>
          <AverageTimePerReviewCard />
        </Col>

        <Col xs={24} sm={12} lg={6}>
          <EstimatedTimeToFinishCard />
        </Col>
      </Row>
      
      {/* Review Pace Chart Section */}
      <Row gutter={16} style={{ marginTop: 16 }}>
        <Col span={24}>
          <HumanReviewProgressCard 
            title='Review Progress by Question' 
            showViewTypeSelector={false} 
            initialViewType='question'
          />
        </Col>
      </Row>
    </div>
  );
};

export default ReviewerDashboard;